export default __webpack_public_path__ + "static/media/distortion.1ded8f85.png";